import { ANSWER } from 'constants/answer';
import { FormSchema } from 'UI/constants/entityTypes';
import { getInitials, getQuestionsCounts } from 'utils';

/**
 * @param {Object} formData
 * @param {Object} questionsPaths
 * @param {string} schemaName
 */
export const getDataSheetCount = (formData, questionsPaths, schemaName) => {
  if (!formData) {
    return {
      total: 0,
      answered: 0
    };
  }

  let finalQuestionsPaths = { ...questionsPaths };

  if (formData.establishingUrgency.onAScaleOf1To10?.question === '10') {
    const {
      'establishingUrgency.onAScaleOf1To10.whatKeepsYouFromBeingA10': _coverDetails,
      ...rest
    } = finalQuestionsPaths;
    finalQuestionsPaths = { ...rest };
  }

  if (
    schemaName !== FormSchema.CandidateDataSheetQuick &&
    formData.establishingUrgency.onAScaleOf1To10?.haveYouMadeSomething?.question === ANSWER.Negative
  ) {
    const {
      'establishingUrgency.onAScaleOf1To10.haveYouMadeSomething.whatStepsHaveYouTaken':
        _stepsHaveYouTaken,
      'establishingUrgency.onAScaleOf1To10.haveYouMadeSomething.whatCompaniesHaveYouAppliedTo':
        _companiesHaveYouAppliedTo,
      ...rest
    } = finalQuestionsPaths;
    finalQuestionsPaths = { ...rest };
  }

  if (formData.workPreferences.relocation.areYouWillingToRelocate === ANSWER.Negative) {
    const {
      'workPreferences.relocation.relocationDestinations': _relocationDestinations,
      ...rest
    } = finalQuestionsPaths;
    finalQuestionsPaths = { ...rest };
  }

  return getQuestionsCounts(formData, finalQuestionsPaths);
};

/**
 * @param {Object} props
 * @param {string} [props.id]
 * @param {Object} props.formData
 * @param {string} props.schemaName
 * @param {number} props.schemaVersion
 * @param {Object} props.progress
 * @param {Object} props.user
 */
export const formatDataSheetDataForAPI = ({
  id,
  formData,
  schemaName,
  schemaVersion,
  progress,
  user
}) => {
  return {
    ...(id && { id }),
    data: formData,
    schema: {
      key: schemaName,
      version: schemaVersion
    },
    progress: {
      current: progress.answered,
      total: progress.total
    },
    trace: {
      user: {
        id: user.id,
        fullName: user.personalInformation.full_name,
        email: user.email,
        initials: getInitials(user.personalInformation.full_name)
      }
    }
  };
};

export const convertDraftToBlueSheetFormat = draftData => {
  return {
    ...draftData,
    time_looking: draftData.timeLooking,
    reason_leaving: draftData.reasonLiving,
    minimum_salary: draftData.minimumSalary,
    no_brainer_salary: draftData.noBrainerSalary,
    good_salary: draftData.goodSalary
  };
};
